var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
import BaseWithPoling from './baseWithPolingApi';
import { REQUEST_PAYLOAD_MAX_BYTES, MAX_PARALLEL_BATCH_PROCESSING, BULK_FAILED_SERIES_REPEAT_IN, } from '../constants';
import { chunkArrByMaxSize, debouncePromise, getObjectSizeInBytes, mergeObjects } from '../utils';
import { v4 } from 'uuid';
export default class BulkContactsCreateApi extends BaseWithPoling {
    constructor(apiCall, batchProcessApi) {
        super(apiCall, batchProcessApi);
        this.apiCall = apiCall;
        this.batchProcessApi = batchProcessApi;
        this.apiBasePath = 'bulk-create';
    }
    bulkCreateContacts(bulkName_1, data_1) {
        return __awaiter(this, arguments, void 0, function* (bulkName, data, options = {}) {
            var _a, e_1, _b, _c;
            try {
                for (var _d = true, _e = __asyncValues(this.trackBulkCreateContacts(bulkName, data, options)), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                    _c = _f.value;
                    _d = false;
                    const { type, results } = _c;
                    if (type === 'results') {
                        return results;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return {
                created: {},
                failed: {},
            };
        });
    }
    logBulkDetails(size, totalContacts, totalBatches, options) {
        options.logger.log('data size             = ', size, ' bytes');
        options.logger.log('total contacts        = ', totalContacts);
        options.logger.log('batches amount        = ', totalBatches);
        options.logger.log('average batch size    ~ ', Math.ceil(totalContacts / totalBatches), ' contacts');
        options.logger.log('parallel batches size = ', options.parallelBatchesAmount || MAX_PARALLEL_BATCH_PROCESSING);
        options.logger.log('batch size            = ', options.batchSize || REQUEST_PAYLOAD_MAX_BYTES, ' bytes');
    }
    trackBulkCreateContacts(bulkName_1, data_1) {
        return __asyncGenerator(this, arguments, function* trackBulkCreateContacts_1(bulkName, data, options = {}) {
            var _a, e_2, _b, _c;
            var _d, _e;
            this.setLogger(options.logger);
            (_d = options.logger) === null || _d === void 0 ? void 0 : _d.log('Starting ', bulkName, ' bulk');
            const startTime = performance.now();
            const dataWithContactKeys = this.updateContactsWithContactKeys(data);
            const { contacts } = dataWithContactKeys, rest = __rest(dataWithContactKeys, ["contacts"]);
            const contactsMaxSize = options.batchSize || REQUEST_PAYLOAD_MAX_BYTES - getObjectSizeInBytes(Object.assign({}, rest));
            const contactsChunks = chunkArrByMaxSize(contacts, contactsMaxSize);
            if (options.logger) {
                this.logBulkDetails(getObjectSizeInBytes(data), contacts.length, contactsChunks.length, options);
            }
            try {
                if (contactsChunks.length === 1 || options.batchesToProcess === 1) {
                    const results = yield __await(this.createContactsInSingleBatch(bulkName, Object.assign(Object.assign({}, dataWithContactKeys), { batchIdx: 0 }), options));
                    yield yield __await({
                        type: 'results',
                        results: this.mergeResults({
                            created: {},
                            failed: {},
                        }, [results]),
                    });
                }
                else {
                    try {
                        for (var _f = true, _g = __asyncValues(this.createContactsInMultiBatches(contactsChunks, rest, bulkName, options)), _h; _h = yield __await(_g.next()), _a = _h.done, !_a; _f = true) {
                            _c = _h.value;
                            _f = false;
                            const results = _c;
                            if (results.type === 'results') {
                                const endTime = performance.now();
                                (_e = options.logger) === null || _e === void 0 ? void 0 : _e.log(`Bulk ${bulkName} completed for ${Math.floor((endTime - startTime) / 1000)} seconds`);
                            }
                            yield yield __await(results);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (!_f && !_a && (_b = _g.return)) yield __await(_b.call(_g));
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            finally {
            }
        });
    }
    updateContactsWithContactKeys(data) {
        const dataWithContactKeys = Object.assign(Object.assign({}, data), { contacts: data.contacts.map((c, idx) => {
                if (c.contactKey !== undefined) {
                    return c;
                }
                return Object.assign(Object.assign({}, c), { contactKey: `${idx}` });
            }) });
        this.checkContactKeysDuplications(dataWithContactKeys.contacts);
        return dataWithContactKeys;
    }
    indicesOn() {
        return __awaiter(this, void 0, void 0, function* () {
            const indicesOnBatchId = v4();
            this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/indices-on/${indicesOnBatchId}`,
            });
            yield debouncePromise(() => this.polling(indicesOnBatchId), 3000);
        });
    }
    indicesOff() {
        return __awaiter(this, void 0, void 0, function* () {
            const indicesOffBatchId = v4();
            this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/indices-off/${indicesOffBatchId}`,
            });
            yield debouncePromise(() => this.polling(indicesOffBatchId), 3000);
        });
    }
    checkContactKeysDuplications(contacts) {
        contacts.map(({ contactKey }) => contactKey).forEach((key, index, array) => {
            if (index !== array.lastIndexOf(key)) {
                throw new Error(`The ${key} contactKey is assigned to more than 1 contact...`);
            }
        });
    }
    createContactsInSingleBatch(batchGroupId, singleBatchData, options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const batchId = v4();
            const { batchIdx } = singleBatchData, data = __rest(singleBatchData, ["batchIdx"]);
            this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/bulk`,
                data: Object.assign(Object.assign({}, data), { batchId,
                    batchGroupId }),
            });
            const batch = yield debouncePromise(() => this.polling(batchId, options.polingDuration), 5000);
            (_a = options.logger) === null || _a === void 0 ? void 0 : _a.log('Completed ', batchIdx, '-th batch');
            return batch;
        });
    }
    mergeResults(current, batchProcesses) {
        return batchProcesses.reduce((acc, batch) => {
            const createdContacts = batch.results.reduce((acc, result) => mergeObjects(acc, JSON.parse(result)), {});
            const failedContacts = batch.messages.reduce((acc, message) => mergeObjects(acc, JSON.parse(message)), {});
            return {
                created: Object.assign(Object.assign({}, acc.created), createdContacts),
                failed: Object.assign(Object.assign({}, acc.failed), failedContacts),
            };
        }, current);
    }
    createContactsInMultiBatches(contactsBatches, data, batchGroupId, options) {
        return __asyncGenerator(this, arguments, function* createContactsInMultiBatches_1() {
            var _a;
            const repeatIn = options.repeatFailedParallelBatchesIn || BULK_FAILED_SERIES_REPEAT_IN;
            const batchPromises = contactsBatches
                .map((chunkContacts, batchIdx) => () => this.createContactsInSingleBatch(batchGroupId, Object.assign({ batchIdx, contacts: chunkContacts }, data), options));
            const progress = {
                totalBatches: contactsBatches.length,
                totalContacts: contactsBatches.map((b) => b.length).reduce((acc, curr) => acc + curr, 0),
                completedBatches: 0,
                completedContacts: 0,
            };
            let results = {
                created: {},
                failed: {},
            };
            const parallelBatchesAmount = options.parallelBatchesAmount || MAX_PARALLEL_BATCH_PROCESSING;
            for (let i = 0; i < (options.batchesToProcess || batchPromises.length); i += parallelBatchesAmount) {
                const startIdx = i;
                const endIdx = i + parallelBatchesAmount;
                const batchesSeries = batchPromises.slice(i, i + parallelBatchesAmount);
                let seriesResults = [];
                try {
                    seriesResults = yield __await(Promise.all(batchesSeries.map((p) => p())));
                }
                catch (e) {
                    (_a = options.logger) === null || _a === void 0 ? void 0 : _a.log(`Failed to execute of ${parallelBatchesAmount} batches, from ${startIdx} to ${endIdx}, repeating attempt...`);
                    seriesResults = yield __await(debouncePromise(() => Promise.all(batchesSeries.map((p) => p())), repeatIn));
                }
                results = this.mergeResults(results, seriesResults);
                progress.completedBatches += batchesSeries.length;
                progress.completedContacts += contactsBatches
                    .slice(i, i + parallelBatchesAmount)
                    .map(batch => batch.length)
                    .reduce((acc, curr) => acc + curr, 0);
                yield yield __await({
                    type: 'progress',
                    results: progress,
                });
            }
            yield yield __await({
                type: 'results',
                results,
            });
        });
    }
}
//# sourceMappingURL=bulkContactsCreateApi.js.map